import { render, staticRenderFns } from "./HealthRecord.vue?vue&type=template&id=37ff85f8&scoped=true&"
import script from "./HealthRecord.vue?vue&type=script&lang=js&"
export * from "./HealthRecord.vue?vue&type=script&lang=js&"
import style0 from "./HealthRecord.vue?vue&type=style&index=0&id=37ff85f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff85f8",
  null
  
)

export default component.exports